if (!customElements.get('clinic-finder')) {
  customElements.define('clinic-finder', class ClinicFinder extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-clinic-search]');
      this.cards = [...this.querySelectorAll('[data-clinic-card]')];
      this.filters = [...this.querySelectorAll('[data-region-filter]')];
      this.region = 'all';
      this.mapMarkers = new Map();
      this.search?.addEventListener('input', () => this.update());
      this.filters.forEach((button) => button.addEventListener('click', () => this.setRegion(button.dataset.regionFilter)));
      this.cards.forEach((card) => {
        card.addEventListener('click', (event) => { if (!event.target.closest('a, button')) this.selectClinic(card.dataset.clinicId); });
        card.addEventListener('keydown', (event) => { if ((event.key === 'Enter' || event.key === ' ') && !event.target.closest('a, button')) { event.preventDefault(); this.selectClinic(card.dataset.clinicId); } });
      });
      this.addEventListener('shopify:block:select', (event) => this.selectClinic(event.target.dataset.clinicId, true));
      this.initMap();
      this.update();
    }
    initMap() {
      const target = this.querySelector('[data-clinic-map]');
      if (!target || !window.L) { if (target) target.textContent = 'The map could not load. Clinic directions remain available below.'; return; }
      this.map = L.map(target, {
        scrollWheelZoom: false,
        dragging: true,
        touchZoom: true,
        doubleClickZoom: false,
        boxZoom: false,
        zoomSnap: 0.1,
        zoomDelta: 0.5,
        zoomAnimation: true,
        fadeAnimation: true,
        zoomControl: true
      }).setView([-33.86, 151.14], 11);
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>' }).addTo(this.map);
      this.cards.forEach((card) => {
        const lat = Number.parseFloat(card.dataset.latitude); const lng = Number.parseFloat(card.dataset.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
        const label = this.escapeHtml(card.dataset.mapLabel || 'Clinic'); const markerUrl = this.escapeHtml(this.dataset.markerUrl || '');
        const icon = L.divIcon({ className: 'clinic-map-marker', html: `<span class="clinic-map-marker__inner"><img src="${markerUrl}" alt=""><span>${label}</span></span>`, iconSize: [112, 76], iconAnchor: [56, 76] });
        const marker = L.marker([lat, lng], { icon, title: card.dataset.mapLabel || 'Clinic' }).addTo(this.map).on('click', () => this.selectClinic(card.dataset.clinicId));
        this.mapMarkers.set(card.dataset.clinicId, marker);
      });
      this.fitMap();
    }
    escapeHtml(value) { const node = document.createElement('div'); node.textContent = value; return node.innerHTML; }
    setRegion(region) {
      this.region = region;
      this.filters.forEach((button) => { const active = button.dataset.regionFilter === region; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active.toString()); });
      this.update();
    }
    update() {
      const term = (this.search?.value || '').trim().toLowerCase(); let visible = 0;
      this.activeSearchTerm = term;
      this.cards.forEach((card) => {
        const match = (!term || card.dataset.search.includes(term)) && (this.region === 'all' || card.dataset.region === this.region);
        card.hidden = !match; if (match) visible += 1;
        const marker = this.mapMarkers.get(card.dataset.clinicId);
        if (marker && this.map) { const showOnMap = match && (this.region !== 'all' || term || card.dataset.region === 'sydney'); if (showOnMap && !this.map.hasLayer(marker)) marker.addTo(this.map); if (!showOnMap && this.map.hasLayer(marker)) marker.removeFrom(this.map); }
      });
      const count = this.querySelector('[data-clinic-count]'); if (count) count.textContent = `${visible} clinic ${visible === 1 ? 'location' : 'locations'}`;
      const empty = this.querySelector('[data-clinic-empty]'); if (empty) empty.hidden = visible !== 0;
      const status = this.querySelector('[data-clinic-status]'); if (status) status.textContent = `${visible} ${visible === 1 ? 'clinic' : 'clinics'} found`;
      this.fitMap();
    }
    fitMap() {
      if (!this.map) return;
      if (this.region === 'all' && !this.activeSearchTerm) {
        this.map.setView([-33.855, 151.13], 11);
        return;
      }
      const markers = [...this.mapMarkers.values()].filter((marker) => this.map.hasLayer(marker)); if (!markers.length) return;
      if (markers.length === 1) this.map.setView(markers[0].getLatLng(), 14); else this.map.fitBounds(L.featureGroup(markers).getBounds(), { padding: [45, 45], maxZoom: 12 });
    }
    selectClinic(id, reveal = false) {
      const card = this.cards.find((item) => item.dataset.clinicId === id); if (!card) return; if (reveal && card.hidden) this.setRegion(card.dataset.region);
      this.cards.forEach((item) => item.classList.toggle('is-active', item === card)); this.mapMarkers.forEach((marker, markerId) => marker.getElement()?.classList.toggle('is-active', markerId === id));
      const marker = this.mapMarkers.get(id);
      if (marker && this.map) {
        if (!this.map.hasLayer(marker)) marker.addTo(this.map);
        this.map.setView(marker.getLatLng(), 17.4, { animate: true });
      }
      if (window.matchMedia(`(max-width: ${window.SaintBreakpoints.locator - 1}px)`).matches) this.querySelector('[data-clinic-map]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}
